export default __webpack_public_path__ + "04468d2f3543cfbfaa7e77b36f28fe74.png";